var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 78,
    height: 80,
    viewBox: "0 0 78 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_5645_19639)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39 74C59.4345 74 76 57.4345 76 37C76 16.5655 59.4345 0 39 0C18.5655 0 2 16.5655 2 37C2 57.4345 18.5655 74 39 74Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.2413 29.3936L31.3941 14.2408L46.579 29.4258L31.4263 44.5786C27.2273 48.7775 20.4295 48.7775 16.2413 44.5786C12.053 40.3796 12.053 33.5818 16.2413 29.3936Z",
    fill: "url(#paint0_radial_5645_19639)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.3937 29.4262C35.5927 33.6252 42.3905 33.6252 46.5787 29.4262C50.767 25.2273 50.7777 18.4294 46.5787 14.2412C42.3798 10.053 35.582 10.053 31.3937 14.2412C27.2055 18.4294 27.1948 25.238 31.3937 29.4262Z",
    fill: "#00BFFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.5795 29.4259L31.4268 44.5787L46.6118 59.7637L61.7645 44.6109C65.9635 40.4119 65.9635 33.6141 61.7645 29.4259C57.5656 25.2377 50.7678 25.2377 46.5795 29.4259Z",
    fill: "url(#paint1_radial_5645_19639)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.6108 44.5787C50.8098 48.7777 50.8098 55.5755 46.6108 59.7637C42.4119 63.952 35.6141 63.9627 31.4258 59.7637C27.2376 55.5648 27.2376 48.767 31.4258 44.5787C35.6248 40.3798 42.4226 40.3798 46.6108 44.5787Z",
    fill: "#976CF3"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_5645_19639",
    x: 0,
    y: 0,
    width: 78,
    height: 80,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5645_19639"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_5645_19639",
    result: "shape"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_5645_19639",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(38.8535 21.58) rotate(135) scale(32.056)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00BFFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00BFFC",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_5645_19639",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(38.7578 52.0508) rotate(-45) scale(32.056)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#976CF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#976CF3",
    stopOpacity: 0
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.68adbdf55e1c4bf119532d929a53aedf.svg";
export { ForwardRef as ReactComponent };